module.exports = __webpack_public_path__ + "img/big3-1.c104b07e.jpg";